var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingsFourHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    viewBox: "0 0 251 46",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: 24,
      width: 130
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tp-star__canvas",
    fill: "#00b67a",
    d: "M0 46.330002h46.375586V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tp-star__shape",
    d: "M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z",
    fill: "#FFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tp-star__canvas",
    fill: "#00b67a",
    d: "M51.24816 46.330002h46.375587V0H51.248161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tp-star__canvas--half",
    fill: "#00b67a",
    d: "M51.24816 46.330002h23.187793V0H51.248161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tp-star__shape",
    d: "M74.990978 31.32991L81.150908 30 84 39l-9.660206-7.202786L64.30279 39l3.895636-11.840666L58 19.841466h12.605577L74.499595 8l3.895637 11.841466H91L74.990978 31.329909z",
    fill: "#FFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tp-star__canvas",
    fill: "#00b67a",
    d: "M102.532209 46.330002h46.375586V0h-46.375586z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tp-star__canvas--half",
    fill: "#00b67a",
    d: "M102.532209 46.330002h23.187793V0h-23.187793z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tp-star__shape",
    d: "M142.066994 19.711433L115.763298 38.80065l3.838215-11.797827-10.047304-7.291391h12.418975l3.837418-11.798624 3.837417 11.798624h12.418975zM125.81156 31.510075l7.183595-1.509576 2.862113 8.800152-10.045708-7.290576z",
    fill: "#FFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tp-star__canvas",
    fill: "#00b67a",
    d: "M153.815458 46.330002h46.375586V0h-46.375586z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tp-star__canvas--half",
    fill: "#00b67a",
    d: "M153.815458 46.330002h23.187793V0h-23.187793z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tp-star__shape",
    d: "M193.348355 19.711433L167.045457 38.80065l3.837417-11.797827-10.047303-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418974zM177.09292 31.510075l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z",
    fill: "#FFF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tp-star__canvas",
    fill: "#dcdce6",
    d: "M205.064416 46.330002h46.375587V0h-46.375587z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tp-star__canvas--half",
    fill: "#00b67a",
    d: "M205.064416 46.330002h23.187793V0h-23.187793z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tp-star__shape",
    d: "M244.597022 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingsFourHalf);
export default __webpack_public_path__ + "static/media/ratingsFourHalf.9ff0b40be0bff246b8267f507f8d3ca5.svg";
export { ForwardRef as ReactComponent };